import React from 'react';
import { BlockStack, Box, DataTable, Divider, InlineGrid, Link, Modal, SkeletonThumbnail, Text, Thumbnail } from '@shopify/polaris';
import PURCHASE_ORDER_STRINGS from '#client/pages/PurchaseOrders/constants/purchaseOrders.en.json';

const CartonsTable = ({ skuToProduct, cartonRows, activeModals, toggleModal, cartonSortDirection, cartonSortColumnIndex, handleSort }) => (
    <>
        <Text variant="headingLg">{PURCHASE_ORDER_STRINGS.CARTONS}</Text>
        <DataTable
            columnContentTypes={['text', 'text', 'text', 'text']}
            headings={[
                PURCHASE_ORDER_STRINGS.PURCHASE_ORDER_ASN.CARTONS_TABLE.CARTON_NUMBER,
                PURCHASE_ORDER_STRINGS.PURCHASE_ORDER_ASN.CARTONS_TABLE.CARRIER,
                PURCHASE_ORDER_STRINGS.PURCHASE_ORDER_ASN.CARTONS_TABLE.TRACKING_NUMBER,
                PURCHASE_ORDER_STRINGS.PURCHASE_ORDER_ASN.CARTONS_TABLE.ITEM_LIST,
            ]}
            rows={cartonRows.map((row, index) => [
                row.cartonNumber,
                row.shipmentCarrier,
                row.shipmentTrackingNumber,
                <Modal
                    key={`modal-${row.cartonNumber}`}
                    activator={
                        <Link
                            key={`link-${row.cartonNumber}`}
                            onClick={(event) => {
                                event.preventDefault();
                                toggleModal(index);
                            }}
                        >
                            {PURCHASE_ORDER_STRINGS.PURCHASE_ORDER_ASN.CARTONS_TABLE.VIEW_ITEMS}
                        </Link>
                    }
                    open={!!activeModals[index]}
                    title={`${row.cartonNumber} ${PURCHASE_ORDER_STRINGS.PURCHASE_ORDER_ASN.CARTONS_TABLE.ITEM_LIST}`}
                    onClose={() => toggleModal(index)}
                >
                    <Modal.Section>
                        <BlockStack>
                            <Box paddingBlock="200">
                                <Text>
                                    {PURCHASE_ORDER_STRINGS.PURCHASE_ORDER_ASN.CARTONS_TABLE.SHOWING} {row?.cartonLines?.length}{' '}
                                    {row?.cartonLines?.length > 1 ? PURCHASE_ORDER_STRINGS.PURCHASE_ORDER_ASN.CARTONS_TABLE.ITEMS : PURCHASE_ORDER_STRINGS.PURCHASE_ORDER_ASN.CARTONS_TABLE.ITEM}
                                </Text>
                            </Box>
                            <Divider />
                            {row.cartonLines.map((line, lineIndex) => {
                                const product = skuToProduct?.[line.sku];

                                return (
                                    <React.Fragment key={`line-${row.cartonNumber}-${lineIndex}`}>
                                        <BlockStack>
                                            <Box paddingBlock="300">
                                                <InlineGrid columns="auto 1fr auto" key={`product-grid-${row.cartonNumber}-${lineIndex}`}>
                                                    {product?.variantImage ? (
                                                        <Thumbnail
                                                            source={product?.variantImage}
                                                            alt={product?.variantImageAltText + ' ' + PURCHASE_ORDER_STRINGS.PRODUCT_IMAGE || PURCHASE_ORDER_STRINGS.PRODUCT_IMAGE}
                                                            size="small"
                                                        />
                                                    ) : (
                                                        <SkeletonThumbnail size="small" />
                                                    )}
                                                    <BlockStack>
                                                        <Box paddingInlineStart="300">
                                                            <Text as="h3" variant="headingSm" fontWeight="medium">
                                                                {product?.variantTitle}
                                                            </Text>
                                                            <Text as="p" variant="bodyMd">
                                                                {PURCHASE_ORDER_STRINGS.SKU}: {line.sku}
                                                            </Text>
                                                        </Box>
                                                    </BlockStack>
                                                    <Text fontWeight="medium">
                                                        {PURCHASE_ORDER_STRINGS.QUANTITY}: {line.quantityExpected}
                                                    </Text>
                                                </InlineGrid>
                                            </Box>
                                            {lineIndex < row?.cartonLines?.length - 1 && <Divider key={`divider-${row.cartonNumber}-${lineIndex}`} />}
                                        </BlockStack>
                                    </React.Fragment>
                                );
                            })}
                        </BlockStack>
                    </Modal.Section>
                </Modal>,
            ])}
            sortable={[true, true, true, false]}
            defaultSortDirection="ascending"
            initialSortColumnIndex={0}
            onSort={(columnIndex, direction) => {
                handleSort(columnIndex, direction);
            }}
            sortDirection={cartonSortDirection}
            sortedColumnIndex={cartonSortColumnIndex}
        />
    </>
);

export default CartonsTable;
